export const Information = () => {
  return (
    <div style={{ padding: "10px" }}>
      <h2>Mudar o status não altera a order na Vtex</h2>
      <br />
      <p>
        O Status Solicitação e o Comentário Interno são apenas sobre a resposta ao formulário e não
        possuem ligação com o pedido!!
      </p>
      <br />
      <p>Para alterar o pedido clique no link na coluna Id Pedido </p>

      <br />
      <p>Para alterar o status e o Comentário Interno clieque no id ou no status </p>
    </div>
  );
};
